import {BOX_SHADOW, COLORS, MAX_WIDTH_WITH_PADDING, bp} from 'core/styles';
import {get} from 'utils/helpers';
import styled, {css} from 'styled-components';
const tileWidth = '334px';

export let OuterContainer = styled.div`
    background-color: ${(props) =>
        props?.user?.type === 'external' ? COLORS.grayLight : '#fff'};
`;

export let InnerContainer = styled.div`
    padding: 30px;
    max-width: ${MAX_WIDTH_WITH_PADDING};
    display: flex;
    flex-flow: column wrap;
    position: relative;
    align-items: start;
    grid-gap: 24px;

    ${bp('xl')} {
        flex-flow: row wrap;
    }
`;

export let ListingContainer = styled.div`
    width: ${tileWidth};
    display: flex;
    flex-flow: column nowrap;
`;

export let ListingTileCss = css`
    padding: 0px;
    margin: 0px;
    boxshadow: ${(props) =>
        get(props, 'user.type') === 'external' ? BOX_SHADOW : '0 2px 5px #000'};
    overflow: hidden;
`;

export let ListingType = styled.div`
    padding: 8px 12px;
    border-radius: 8px;
    background: #eee;
`;

export let InnerAnalytics = styled.div`
    padding: 15px;
    min-height: 127px;
`;

export let InnerAnalyticsBottom = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
`;

export let name = {
    cursor: 'pointer',
    color: COLORS.primary,
    fontWeight: 900,
    fontSize: '18px',
    textDecoration: 'underline',
    marginBottom: '10px',
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};

export let defaultPhoto = {
    display: 'block',
    width: tileWidth,
    height: '166px',
};

export let loading = {
    padding: '30px',
    color: '#fff',
};

export let ListingsShowAll = styled.div`
    cursor: pointer;
    font-size: 14px;
    color: ${COLORS.primary};
    font-weight: 900;
    text-decoration: underline;
    position: absolute;
    right: 45px;
    bottom: 0px;
`;

export let ListingPhoto = styled.div`
    cursor: pointer;
    height: 166px;
    background-color: ${COLORS.primaryLight};
    display: inline-block;
    vertical-align: middle;
    // border-radius: 50%;
    overflow: hidden;
`;

/* copied from elsewhere */
export const encodePhotoSrc = (src) => {
    let url = '';
    if (src && typeof src === 'string') {
        url = src.match(/s/g) ? encodeURI(src) : src;
    }
    if (url && url.split(';').length > 2) {
        url = url.split(';').slice(1, url.split(';').length).join(';');
    }
    return url;
};

export let ListingImg = styled.img`
    background-size: cover;
    background-position: center;
    width: ${tileWidth};
    height: 166px;
    // background-image: ${(props) =>
        props.src ? 'url("' + encodePhotoSrc(props.src) + '")' : 'none'};
`;
